<script>
  import { Route } from "svelte-routing";
  import axios from "axios";

  export let path;
  export let component;
  export let redirectTo;

  const params = window.location.search;

  async function decryptParams() {
    if (!params || params.search(/^\?d=.*/) === -1) {
      throw Error("wrong params");
    }

    try {
      const dataParam = params.split("=")[1];
      const response = await axios.post(
        // Make sure the BACKEND_URL is set via the build process (package.json)
        `${process.env.BACKEND_URL}/api/v1/getParams`,
        {
          param: dataParam,
        }
      );

      // Wait for 1 second before loading
      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (process.env.DEMO_MODE) {
        return {
          params: {
            cid: "CP001",
            port: 1,
          },
        };
      }
      return response.data;
    } catch (error) {
      throw Error("invalid params");
    }
  }
</script>

{#await decryptParams()}
  <p>Initializing...</p>
{:then params}
  <Route {path} {component} {params} />
{:catch error}
  <Route component={redirectTo} {error} />
{/await}
